var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99888 14.0024H2.66499C2.29684 14.0024 1.99805 13.7036 1.99805 13.3355L1.99805 9.33381C1.99805 8.96566 2.29684 8.66687 2.66499 8.66687H3.99888C4.36703 8.66687 4.66582 8.96566 4.66582 9.33381V13.3355C4.66582 13.7036 4.36703 14.0024 3.99888 14.0024Z",
    stroke: "#5A5A5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66768 11.3346H10.2237C10.5125 11.3346 10.7932 11.2413 11.024 11.0679L12.6353 9.85936C13.0375 9.55791 13.6004 9.59792 13.9559 9.9534V9.9534C14.3507 10.3482 14.3507 10.9878 13.9559 11.382L12.5733 12.7646C12.2012 13.1367 11.7263 13.3908 11.2101 13.4942L9.25593 13.885C8.86843 13.9624 8.46893 13.9531 8.08544 13.857L6.31804 13.4155C6.10662 13.3622 5.88986 13.3355 5.67177 13.3355H4.66602",
    stroke: "#5A5A5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66768 11.3346H9.6581C10.2163 11.3346 10.6685 10.8825 10.6685 10.3242V10.1221C10.6685 9.65862 10.3531 9.25445 9.90353 9.1424L8.37489 8.76024C8.12612 8.69822 7.87135 8.66687 7.61524 8.66687V8.66687C6.99699 8.66687 6.39207 8.84961 5.87785 9.19309L4.66602 10.0008",
    stroke: "#5A5A5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96731 2.78044L5.88269 2.78245C5.70595 2.78245 5.53654 2.85314 5.41183 2.97786L4.8616 3.52809C4.60082 3.78886 4.60082 4.21104 4.8616 4.47115L5.41383 5.02338C5.53855 5.1481 5.70862 5.21879 5.88536 5.21813L8.96931 5.21613L8.97664 5.21679C9.41883 6.07515 10.3039 6.6674 11.337 6.66606C12.8096 6.66206 14.0034 5.4649 14.0034 3.99295C14.0041 2.52034 12.8116 1.32917 11.339 1.33051C10.3099 1.33318 9.42683 1.92609 8.98265 2.78111",
    stroke: "#5A5A5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3371 4.17435C11.4331 4.17435 11.5105 4.09632 11.5105 4.00028C11.5105 3.90424 11.4318 3.82621 11.3364 3.82621C11.2404 3.82621 11.1623 3.90424 11.1623 4.00028C11.1623 4.09632 11.2404 4.17435 11.3371 4.17435",
    stroke: "#5A5A5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandKey);
export default __webpack_public_path__ + "static/media/hand-key.0648f7b2e9c8d336abfcdc75ab1205c3.svg";
export { ForwardRef as ReactComponent };